import { makeStyles } from "@fluentui/react-components";

export const useDocHeaderStyles = makeStyles({
  docHeader: {
    display: "flex",
    flexDirection: "row",
    columnGap: "5px",
    flexWrap: "nowrap",
    justifyContent: "flex-start",
    alignContent: "center",
    maxWidth: "90%",
  },

  docTitle: {
    textOverflow: "ellipsis",
  },
});
